import React from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
import { Container, Row, Col } from 'react-bootstrap'

import First from './First'
import Second from './Second'
import Third from './Third'
import Content from './Content/Content'

import List from './List'

// import mainContent from './mainContent.svg'

import arrowDownIcon from '../../assets/icons/arrow-down.svg'
import Header from './Header'

class Main extends React.Component {
  render() {
    return (
      <Wrapper>
        <Container>
          <Header />
          <Row>
            <Col sm={6}>
              <First />
            </Col>
            <Col sm={6}>
              <Second />
              <Third />
            </Col>
          </Row>
          <List />
          <Row>
            <ArrowDown src={arrowDownIcon} />
          </Row>
          {/* <MainContent src={mainContent} /> */}
          <Content {...this.props} />
        </Container>
      </Wrapper>
    )
  }
}

export default connect(state => state, {})(Main)

const Wrapper = styled.div`
  /* height: calc(100vh - 170px);
  overflow: hidden;
  overflow-y: auto; */
`
// const MainContent = styled.img`
//   max-width: 100%;
// `
const ArrowDown = styled.img`
  margin: 30px auto;
`
